import React from 'react';
import './splashscreen.css';

function LoadingMessage() {
  return (
    <div className="splash-screen">
      <img src="./img/splash-screen.gif" alt="splash-screen" />
    </div>
  );
}

export default LoadingMessage;
